
import { onMounted, ref, Ref, watch } from 'vue';
import { sendLog, immediateSendLog, radarLog } from '@/common/radar';
import { genWebDidAndSessionId } from '@/common/utils';


export const useWatchVideoLog = ({ slideIndex, photo_id, pre_photo_id, author_id }: Record<string, Ref>) => {
  const activeVideoPlayingTime = ref(0) // 当前视频播放起始时间
  const startPlayTime = ref(0) // 当前视频setPlay的时间
  // 视频消费时长上报
  const sendVideoTimeLog = () => {
    const nowTime = new Date().getTime()
    const play_duration = nowTime - activeVideoPlayingTime.value
    // 包含暂停时间
    sendLog({
      type: 'click',
      name: 'PLAY_PHOTO',
      value: {
        photo_id: pre_photo_id.value,
        play_duration,
      }
    })
  }

  const sendPlayToPlayingTimeLog = ({ index }: { index: number }) => {
    const { webDid, sessionId } = genWebDidAndSessionId();
    const nowTime = new Date().getTime()
    const time = nowTime - startPlayTime.value

    radarLog({
      name: 'PLAY_TO_PLAYING_TIME',
      event_type: 'PLAY_TO_PLAYING_TIME',
      category: 'KWAI_SHARE',
      src: window.location.pathname,
      extra_info: JSON.stringify({
        playToPlayingTime: time,
        index,
        sessionId
      }),
    });
  }
  onMounted(() => {
    // 监听当前index变化
    watch(() => slideIndex.value, () => {
      sendVideoTimeLog()
    })
    // 统计观看
    watch(() => slideIndex.value, () => {
      // 规避在pv上报前上报
      setTimeout(() => {
        immediateSendLog({
          type: 'show',
          name: 'PLAY_PHOTO',
          value: {
            photo_id: photo_id.value,
            author_id: author_id.value
          }
        })
      }, 0)
    }, {
      immediate: true
    })
  })
  return {
    activeVideoPlayingTime,
    sendVideoTimeLog,
    startPlayTime,
    sendPlayToPlayingTimeLog
  };
};

